import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { AppService } from '@src/suite/app.service';
import { ClipboardTypes } from '@src/suite/common/enums/clipboard-types';
import { selectSupervisor } from '@src/suite/common/store/hello-results/hello-results.selectors';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectPlaybookListRecords } from '@src/suite/common/store/playbook/playbook.selector';

@Component({
    selector: 'st-templates-secondary-cta',
    imports: [MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './templates-secondary-cta.component.html',
    styleUrl: './templates-secondary-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-templates-secondary-cta',
    },
})
export class TemplatesSecondaryCtaComponent {
    store = inject(Store);
    appService = inject(AppService);

    languageSettings = this.store.selectSignal(selectI18N);
    readonly isSupervisor = this.store.selectSignal(selectSupervisor);
    readonly selectListRecords = this.store.selectSignal(selectPlaybookListRecords);

    public copyToClipboard() {
        this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.TemplatesView);
    }
}
